const resultFunction = (loading) => !loading

const experimentsAvailableSelectorDefinition = {
  id: 'experimentsAvailable',
  resultFunction,
  dependencies: [{ selector: 'loading' }],
}

export default experimentsAvailableSelectorDefinition
